import { Button, Typography } from '@mui/material';

import { OrganizationUser } from 'src/types/resources/Organization';
import { CreateOrganizationUserFormData } from 'src/forms/createOrganizationUser';
import { IndexParams } from 'src/repositories/superAdmin/OrganizationsUsersRepository';
import useModals from 'src/hooks/useModals';
import Box from 'src/components/Box';

import styles from './styles';

type OnUpdateUserParams = {
  id: number;
  params: Partial<CreateOrganizationUserFormData>;
};

type FormProps = {
  user: OrganizationUser;
  onLoadUsers: (params: IndexParams) => void;
  onUpdateUser: (params: OnUpdateUserParams) => void;
};

const Form: React.FC<FormProps> = props => {
  const { user, onLoadUsers, onUpdateUser } = props;
  const { id, organizationId, hasTimeSheetApproval } = user;

  const { hideModal } = useModals();

  const formText = hasTimeSheetApproval
    ? 'You are restricting this user from access to the Time Sheets. They will not be able to approve and edit them.'
    : 'You are providing this user with access to the Time Sheets. They will be able to approve and edit them.';

  const handleSubmit = async () => {
    await onUpdateUser({ id, params: { hasTimeSheetApproval: !hasTimeSheetApproval } });
    onLoadUsers({ organizationId });
    hideModal();
  };

  return (
    <Box sx={styles.wrapper}>
      <Typography variant="h2" sx={styles.title}>
        Are you sure?
      </Typography>
      <Typography variant="body1" sx={styles.text}>
        {formText}
      </Typography>
      <Box>
        <Button variant="contained" sx={styles.button} onClick={handleSubmit}>
          Yes, proceed
        </Button>
        <Button variant="outlined" sx={styles.button} onClick={hideModal}>
          Cancel
        </Button>
      </Box>
    </Box>
  );
};

export default Form;
